import Section from './_Section'
import ButtonEl from '../helpers/ctas/Button'
import { transformPaddingToTailwind } from '../../helpers/style'

function BasicContent(props) {
  const componentPadding = transformPaddingToTailwind(props.componentPadding)
  const alignment = props.contentAlignment?.toLowerCase() || 'left'

  // Determine text alignment class
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'

  // Determine CTA alignment class
  const ctaAlignClass = props.ctaLinkAlignment === 'Center' ? 'justify-center' : 'justify-start'

  return (
    <Section type="basicContent" outerClass={componentPadding} innerClass="px-7" headingClass={textAlignClass} {...props}>
      {props.ctaLink?.length > 0 && (
        <div data-type="cta-links" className={`flex flex-wrap ${ctaAlignClass} gap-4 max-sm:gap-3`}>
          {props.ctaLink.map((ctaLinkItem, i) => (
            <ButtonEl
              key={i}
              link={ctaLinkItem.link}
              theme={ctaLinkItem.linkType.toLowerCase()}
              icon={ctaLinkItem.linkIconClass}
              position={ctaLinkItem.linkPosition}
            />
          ))}
        </div>
      )}
    </Section>
  )
}

export default BasicContent
